/*
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ESearchEntitySubType {
  None = -1,
  Geofence = 0,
  Hotspot = 1,
}
